import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asRooms" }
const _hoisted_2 = { class: "asRooms_room" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "asRooms_status" }, null, -1)
const _hoisted_4 = { class: "asRooms_message" }
const _hoisted_5 = { class: "asRooms_room" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "asRooms_status" }, null, -1)
const _hoisted_7 = { class: "asRooms_message" }
const _hoisted_8 = { class: "asRooms_room" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "asRooms_status" }, null, -1)
const _hoisted_10 = { class: "asRooms_message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_as_skeleton = _resolveComponent("as-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_avatar asRooms_avatar" }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_author" }),
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_text" })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_avatar asRooms_avatar" }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_author" }),
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_text" })
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_avatar asRooms_avatar" }),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_author" }),
        _createVNode(_component_as_skeleton, { class: "asMessageSkeleton_text asRooms_text" })
      ])
    ])
  ]))
}